import * as fs from 'fs';
import * as path from 'path';
import { JestToGherkin } from './JestToGherkin';
export * from './JestToGherkin';
function createTranspiler(pathTestsInput) {
    const source = fs.readFileSync(pathTestsInput).toString();
    const transpiler = new JestToGherkin();
    transpiler.fileName = path.basename(pathTestsInput);
    const _o = transpiler.transpile(source, {
        fileName: pathTestsInput
    }).outputText;
    return transpiler;
}
export function compose(options) {
    const { pathTestsInput } = options;
    const transpiler = createTranspiler(pathTestsInput);
    return transpiler.outputCode();
}
export function generateComments(options) {
    const { pathTestsInput } = options;
    const transpiler = createTranspiler(pathTestsInput);
    return transpiler.generateComments();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6IiIsIm5hbWVzIjpbXSwiaWdub3JlTGlzdCI6W10sInNvdXJjZXMiOltdLCJzb3VyY2VzQ29udGVudCI6W119